import { useQuery } from "@tanstack/react-query";
import { api, withClientTimeout } from "../lib/api";
import type { TaskRunBriefDetail } from "../../../shared/types";

export function useTaskRunBrief(runId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: ["task-run-brief", runId],
    queryFn: () => withClientTimeout((signal) =>
      api.get<{ data: TaskRunBriefDetail }>(`/api/task-runs/${encodeURIComponent(runId!)}/brief`, signal)),
    enabled: !!runId && enabled,
    retry: false,
  });
}
